import { z } from 'zod';

export const DLN_SOURCE = [
  'ai_output',
  'api_integration',
  'api_poller',
  'demo_dln',
  'email',
  'email_scan',
  'ftp',
  'legacy',
  'mobile_ocr',
  'mobile_ocr_validated',
  'mobile_ocr_fast',
  'mobile_qr',
  'reparsing',
  'unknown',
  'web_upload',
] as const;

export const zodDlnSourceSchema = z.enum(DLN_SOURCE);

export type DlnSource = (typeof DLN_SOURCE)[number];
